import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './file.scss';
import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import { FILE_STATUS } from '../constants';
import FileStatus from './FileStatus';
var File = function File(_ref) {
  var disabled = _ref.disabled,
    file = _ref.file,
    progress = _ref.progress,
    removeFile = _ref.removeFile,
    children = _ref.children;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "file file-basic file-".concat(file.status)
  }, /*#__PURE__*/React.createElement("div", {
    className: "clearfix"
  }, /*#__PURE__*/React.createElement("div", {
    className: "float-end"
  }, /*#__PURE__*/React.createElement(FileStatus, {
    file: file,
    progress: progress,
    removeFile: removeFile
  })), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-file"
  }), file.name, children), removeFile && file.status === FILE_STATUS.STATUS_UPLOAD_SUCCESS ? /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Remove'),
    type: "button",
    className: "float-end remove btn-link",
    disabled: disabled || !file.identity,
    onClick: removeFile
  }, /*#__PURE__*/React.createElement(T, {
    source: "Remove"
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "clearfix"
  }));
};
export default File;